import { Link } from "react-router-dom";
import type { MediaItem } from "../../content";

type MediaGridProps = {
  items: MediaItem[];
  openLabel: string;
  emptyLabel: string;
  getViewHref: (item: MediaItem) => string;
};

export function MediaGrid({
  items,
  openLabel,
  emptyLabel,
  getViewHref,
}: MediaGridProps) {
  if (!items.length) {
    return <p className="media-empty">{emptyLabel}</p>;
  }

  return (
    <>
      <div className="media-grid">
        {items.map((item, index) => (
          <article key={item.id} className="media-card">
            <div className="media-thumb-wrap">
              <img
                src={item.thumbnail}
                alt={item.title}
                className="media-thumb"
                loading="lazy"
                decoding="async"
                onError={(event) => {
                  event.currentTarget.src = "/logo.svg";
                }}
              />
            </div>
            <div className="media-card-body">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <Link className="media-link" to={getViewHref(item)}>
                {openLabel}
              </Link>
            </div>
          </article>
        ))}
      </div>
    </>
  );
}
